export const PARAMETERS = {
  HostedZoneId: 'HostedZoneId',
  DomainName: 'DomainName',
  RepoOwner: 'RepoOwner',
  RepoName: 'RepoName',
  RepoBranch: 'RepoBranch',
  RepoToken: 'RepoToken',
  OpenAIAPIKey: 'OpenAIAPIKey',
  OpenAIModelId: 'OpenAIModelId',
};

export const STACK_IDS = {
  LocalUIDevelopmentDomainName: 'LocalUIDevelopmentDomainName',
  UserManagement: 'UserManagement',
  AdminGroup: 'AdminGroup',
  APICloudFunction: 'APICloudFunction',
  APICloudFunctionGateway: 'APICloudFunctionGateway',
  SSLCertificate: 'SSLCertificate',
  LiveUIFiles: 'LiveUIFiles',
  LiveAPIFiles: 'LiveAPIFiles',
  MainCDN: 'MainCDN',
  UIBuildPipeline: 'UIBuildPipeline',
  APIBuildPipeline: 'APIBuildPipeline',
  MainCDNCloudFront: 'MainCDNCloudFront',
  DatabaseMessageHistoryTable: 'DatabaseMessageHistoryTable',
  DatabaseUserInfoTable: 'DatabaseUserInfoTable',
  DatabaseUserProfileTable: 'DatabaseUserProfileTable',
};

export const USER_MANAGEMENT_ASSET_NAMES = {
  ROLE_NAMES: {
    AUTH: 'leadAdvisorHireCallingAuthRole',
    UNAUTH: 'leadAdvisorHireCallingUnauthRole',
  },
  GROUPS: {
    ADMIN: 'userManagementAdminGroup',
  },
};
